import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store';
import { App } from './app';

// Configure pdf.js worker
declare const pdfjsLib: any;
if (typeof pdfjsLib !== 'undefined') {
    pdfjsLib.GlobalWorkerOptions.workerSrc =
        'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
}

const root = document.getElementById('app');
if (root) {
    createRoot(root).render(
        <Provider store={store}>
            <App />
        </Provider>
    );
}
